"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter, ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="202299" className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3 text-sm text-muted-foreground">
        <li data-index={0}><Link to="#" className="hover:text-secondary transition-colors">Digital Ticketing</Link></li>
        <li data-index={1}><Link to="#" className="hover:text-secondary transition-colors">QR-Based Entry</Link></li>
        <li data-index={2}><Link to="#" className="hover:text-secondary transition-colors">Real-time Analytics</Link></li>
        <li data-index={3}><Link to="#" className="hover:text-secondary transition-colors">Event Commerce</Link></li>
      </ul>;
  }
  return <ul className="space-y-3 text-sm">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const socialLinks = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section id="site-footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          
          {}
          <div className="space-y-6">
            <Link to="#" className="inline-block">
              <WvcLogo className="h-8 w-auto text-foreground" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              MilleMaster is a modern, AI-driven ticketing platform helping festivals and promoters sell smarter and own their customer relationships end-to-end.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-default font-semibold text-lg tracking-tight">Platform</h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-default font-semibold text-lg tracking-tight">Get in Touch</h3>
            <ul className="space-y-4 text-sm text-muted-foreground">
              <li className="flex items-start gap-3">
                <MapPin className="size-4 mt-0.5 shrink-0 text-secondary" />
                <Link to="https://maps.google.com/?q=123+Tech+Plaza,+San+Francisco,+CA+94103" newTab className="hover:text-secondary transition-colors leading-tight">
                  123 Tech Plaza, San Francisco, CA 94103
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-secondary" />
                <Link to="tel:+15559876543" className="hover:text-secondary transition-colors">
                  (555) 987-6543
                </Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-secondary" />
                <Link to="mailto:hello@millemaster.com" className="hover:text-secondary transition-colors">
                  hello@millemaster.com
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-default font-semibold text-lg tracking-tight">Connect</h3>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} aria-label={social.label} className="flex items-center justify-center size-10 rounded-md bg-muted/50 text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-sm">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

        </div>

        <Separator className="mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} MilleMaster. All rights reserved.
          </p>
          <Button variant="outline" size="sm" onClick={scrollToTop} className="group rounded-md px-4 font-default">
            Back to Top
            <ArrowUp className="size-4 ml-2 group-hover:-translate-y-1 transition-transform duration-300" />
          </Button>
        </div>
      </div>
    </section>;
}